import { useTranslate } from 'hooks/useTranslate';
import { FC, ChangeEvent } from 'react';

type Props = {
  pauseAllPlans: boolean;
  handleChangePauseAllPlans: (event: ChangeEvent<HTMLInputElement>) => void;
};

const PauseBeneficiaryAllPlansSection: FC<Props> = ({
  pauseAllPlans,
  handleChangePauseAllPlans,
}) => {
  const { t } = useTranslate();

  return (
    <div className="form-group">
      <label className="form-label" htmlFor="default-01">
        {t('AllPlansPauseMessage1')}
      </label>

      <div className="row">
        <div className="col-md-6">
          <div className="form-group mt-2">
            <div className="custom-control custom-control-xs custom-checkbox">
              <input
                type="checkbox"
                id="checkbox-all-plans-pause"
                className="custom-control-input"
                checked={pauseAllPlans}
                onChange={handleChangePauseAllPlans}
              />
              <label
                className="custom-control-label"
                htmlFor="checkbox-all-plans-pause"
              >
                {t('AllPlansPauseMessage2')}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PauseBeneficiaryAllPlansSection;
